module.exports = "/work-site/img/larmType.2be09cd6.png";